import React from 'react'
import { View, SafeAreaView, TouchableOpacity } from 'react-native'
import PropTypes from 'prop-types'

import { VFText, VFButton, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { withTheme, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { Images } from '../../Themes'

import styles from './ModalContent.Styles'

const ModalContent = ({
  onClose,
  error,
  errorMessage,
  successMessage,
  onButtonPress,
  onCancelPress,
  theme,
}) => {

  const themedImages = getThemeImages(theme.name)

  return (
    <SafeAreaView style={styles.container}>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={onClose}
        activeOpacity={1}
      >
        <Icon
          name={themedImages.ic_close}
          size={25}
          type="image"
        />
      </TouchableOpacity>
      <View style={styles.orderScreenContainer}>
        <Icon
          name={error ? Images.warning : Images.success}
          type="image"
          size={120}
          resizeMode="contain"
        />
        <VFText
          i18nKey={error ? 'acquisition_order_completion_error' : 'acquisition_order_completion_success'}
          style={styles.title}
        />
        <VFText
          i18nKey={error ? (errorMessage ? errorMessage : 'acquisition_order_completion_error_default_desc') : (successMessage ? successMessage : 'acquisition_order_completion_success_default_desc')}
          style={styles.subtitle(theme)}
        />
      </View>
      <VFButton
        type="primary"
        title={!error ? 'acquisition_check_order' : 'acquisition_go_back_to_summary'}
        style={styles.btnStyle}
        onPress={onButtonPress}
      />
      {!error &&
        <VFButton
          type="secondary"
          title="acquisition_order_completion_success_button_cancel"
          style={[styles.btnStyle, styles.cancelBtnStyle]}
          onPress={onCancelPress}
        />
      }
    </SafeAreaView>
  )
}

ModalContent.propTypes = {
  onClose: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  successMessage: PropTypes.string,
  onButtonPress: PropTypes.func,
  onCancelPress: PropTypes.func
}

export default withTheme(ModalContent)
